<template>
  <div class="wg-row">
    <contact-view v-if="!edit" :contact="contact"></contact-view>
    <world-contact-form 
      v-else
      :contactRef="contact"
      :title="false"
      @closeForm="endEdit"
      :afterSaveFn="endEdit"
      :hasCompanyHinting="true"
    ></world-contact-form>
    <div class="vertical-height-div" style="height:47px;"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ContactView from './contact-details/ContactView.vue';
import WorldContactForm from '../../../../world/spa/components/WorldContactForm.vue';

export default {
  props: {
    contactId: [String, Number],
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      showDeleteDialog: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang
    }),
    contact(){
      return this.$store.getters["contacts/get"](this.contactId);
    }
  },
  methods: {
    endEdit() {
      this.$emit('endEdit');
    }
  },
  components: {
    ContactView,
    WorldContactForm
  }
};
</script>

<style lang="scss" scoped>
  .details-box {
    padding: 10px;
    flex-wrap: nowrap;
    align-items: center;
    box-sizing: border-box;
    min-height: 120px;
  }
  .details-box .image {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }
  .details-box .name {
    font-size: 22px;
  }
</style>
